import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmStageListWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.stage-list",
  name: "Opportunities by stage",
  description: "Opportunities by stage as a compact RQL list.",
  apps: [
    "home",
    "crm",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "field",
          field: "stage",
          as: "stage",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "prospect_id",
          as: "opportunities",
        },
      ],
      group_by: [
        {
          field: "stage",
        },
      ],
      order_by: [
        {
          ref: "opportunities",
          direction: "desc",
        },
      ],
      limit: 8,
      where: {
        type: "condition",
        field: "prospect_type",
        operator: "eq",
        value: "opportunity",
      },
    },
  },
  inputs: {
    title: "Opportunities by stage",
    columns: [
      {
        key: "stage",
        label: "Stage",
      },
      {
        key: "opportunities",
        label: "Opportunities",
        align: "end",
        format: "number",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [
      {
        stage: "Qualified",
        opportunities: 12,
      },
      {
        stage: "Proposal",
        opportunities: 7,
      },
      {
        stage: "Won",
        opportunities: 4,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
